import React from "react";

import Navbar from "../../components/Navbar";
import marketImg from "../../assets/img/services/marketPlace/MarketImg.png";
import BG from "../../assets/img/services/marketPlace/marketBG.png";
import central from "../../assets/img/services/marketPlace/central.png";

function MarketPlace() {
  return (
    <div className="h-screen w-full flex flex-col justify-start bg-gradient-to-b from-[#2B2E82] to-[#0A0918] bg-cover bg-center overflow-y-auto overflow-x-hidden lg:overflow-hidden text-left">
      <div
        className={`h-screen w-full flex flex-col justify-start bg-gradient-to-b from-[#2B2E82] to-[#0A0918] bg-cover bg-center bg-no-repeat md:flex`}
        style={{
          backgroundImage: `url(${BG})`,
        }}
      >
        <Navbar />
        <div className="flex flex-col h-full items-center">
          <div className="flex flex-col lg:flex-row w-[80%] m-auto">
            <div className="w-full lg:w-1/2">
              <img
                src={marketImg}
                alt=""
                className="m-auto w-[50%] lg:w-[60%] -mt-[5%] mb-10"
              />
            </div>
            <div className="flex items-center justify-center md:w-[80%]">
              <div className="block">
                <div className="text-[14px] lg:text-[24px] text-white md:text-left uppercase mb-5">
                  Metaverse service
                </div>
                <div>
                  <p className=" text-white  md:text-left break-words lg:w-[90%] mb-5 text-xs md:text-lg">
                    The metaverse is a collection of every virtual world built
                    using blockchain technology. They can be gaming planets or
                    NFT galleries, curated lands or digital streets. The main
                    thing to always remember when you think about the metaverse
                    is that it is not one place. It is the aggregate of the new
                    digital spaces that people are calling the next iteration of
                    the internet.
                  </p>
                  <div className="flex">
                    <div
                      className="rounded-[13px] border border-solid border-white lg:p-[0.5rem] lg:scale-[1] sm:scale-[0.6] sm:ml-[-5rem] sm:-mt-[3rem]"
                      style={{ background: "rgba(12,16,69,0.38)" }}
                    >
                      <div className="p-[0.5rem]">
                        <img src={central} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fixed -bottom-[12%] font-Gothic text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] h2Mobile lg:block hidden">
          MARKETPLACE
        </h2>
        <h2 className="fixed -bottom-[12%] font-Gothic text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] h2Mobile lg:hidden block">
          EFFICIENCY
        </h2>
      </div>
    </div>
  );
}

export default MarketPlace;
